import { AuditsPage as AuditsPageMobile } from "./auditsPageMobile";

export function AuditsPage() {
  return <AuditsPageMobile />;
}
